<template>
  <div class="sf-accordion-item" :class="itemClass" :data-testid="testId">
    <div class="sf-accordion-item__content-container">
      <div
        class="sf-accordion-item__title"
        @click.prevent.stop="handleItemClick"
      >
        <slot name="title" />
      </div>
      <div v-if="isActive" class="sf-accordion-item__description">
        <slot name="description" />
      </div>
      <div v-if="isActive" class="sf-accordion-item__content">
        <slot name="content" />
      </div>
      <span
        class="sf-accordion-item__icon"
        data-testid="sf-accordion-expand-icon"
        :class="iconClass"
        @click.prevent.stop="handleItemClick"
      >
        <font-awesome-icon
          v-if="props.checked"
          width="24px"
          height="24px"
          :icon="['fas', 'check-circle']"
        />
      </span>
    </div>
    <div
      class="sf-accordion-item__caret-container"
      data-testid="sf-accordion-expand-caret"
      @click.prevent.stop="handleItemClick"
    >
      <div class="sf-accordion-item__caret" :class="caretClass">
        <font-awesome-icon
          width="12px"
          height="12px"
          :icon="['fas', 'caret-down']"
        />
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faCaretDown, faCheckCircle } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { computed } from 'vue'

// eslint-disable-next-line no-undef
defineOptions({
  name: 'SfAccordionItem',
})

interface Props {
  checked?: boolean
  currentActiveIndex: string
  index: string
  last?: boolean
}

const props = defineProps<Props>()

const emit =
  defineEmits<{
    'item-clicked': [index: string]
  }>()

library.add(faCaretDown)
library.add(faCheckCircle)

const isActive = computed(() => props.index === props.currentActiveIndex)
const caretClass = computed(() =>
  isActive.value ? 'sf-accordion-item__caret--expanded' : null
)
const iconClass = computed(() => ({
  'sf-accordion-item__icon--active': isActive.value,
  'sf-accordion-item__icon--checked': props.checked,
}))

const itemClass = computed(() => ({
  'sf-accordion-item--active': isActive.value,
  'sf-accordion-item--last': props.last,
}))

const testId = computed(() =>
  isActive.value ? 'sf-accordion-item-expanded' : 'sf-accordion-item'
)

const handleItemClick = () => {
  emit('item-clicked', props.index)
}
</script>
<style lang="scss" scoped>
@import './sf-accordion-item';
</style>
